import React from "react";
import { Spin } from 'antd';

export default function Loader({message = "", containerStyle = {}}) {
    const defaultContainerStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        ...containerStyle,
    };

    const contentStyle = {
        background: 'rgba(0, 0, 0, 0.05)',
        borderRadius: 8,
        minHeight: '35px',
        minWidth: '60px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 10,
        width: '100%',
        height: '100%',
    };

    return (
        <div style={defaultContainerStyle}>
            <div style={contentStyle}>
                <Spin tip={message ? message : "Loading"} />
            </div>
        </div>
    );
}
